import { _ as __rest, a as __assign } from '../../tslib.es6-21effb23.js';
import { c as classNames } from '../../index-29eed6c4.js';
import * as React from 'react';
import { s as skeletonStyles } from '../../skeleton.module-4f527a2f.js';

var Skeleton = function (_a) {
    var className = _a.className, width = _a.width, height = _a.height, otherProps = __rest(_a, ["className", "width", "height"]);
    return (React.createElement("div", __assign({ "aria-busy": true, className: classNames(skeletonStyles.skeleton, className), style: { width: width, height: height } }, otherProps)));
};

export { Skeleton };
